(ns teamoesterreich.admin-mode.event-alarm.detail.alarm-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [reagent.core :as r]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.data.eventAlarm :as d-eventAlarm]
            [teamoesterreich.admin-mode.event-alarm.detail.alarm-message :as alarm-message]
            [teamoesterreich.admin-mode.event-alarm.detail.alarm-event-selector :as event-selector]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]))



;:eventAlarm-smsText
;:eventAlarm-pushText
;:eventAlarm-emailText




(defn get-base [!actual-alarm !event-detail-loaded? disabled]
  (let [!st (r/atom {:edit-mode false :data {} :copy-modal false})
        !edit-mode (r/cursor !st [:edit-mode])
        !ws-update-lock (r/cursor store/app-state [:ws-update-lock])
        set-edit-mode-fn (fn [b] (reset! !ws-update-lock b) (reset! !edit-mode b))
        !data (r/cursor !st [:data])
        !orgId (r/cursor !st [:data :eventAlarm-orgId])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!actual-alarm key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!actual-alarm key))))
            has-changes? (or
                           (changed? :eventAlarm-orgId)
                           (changed? :eventAlarm-name)
                           (changed? :eventAlarm-channel)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))

            ]

        (when (nil? @!orgId) (reset! !orgId (:eventAlarm-orgId @!actual-alarm)))

        [mui/card
         (log/debug "rerender form " (clj->js @!data))
         [mui/card-header {:title "Details"}]
         ;[mui/card-content [:span "test date " (h-date/parse-local-date (:eventAlarm-acceptableUntil @!actual-alarm))]]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }

           [mui/grid
            {:item  true
             :xl    6
             :md    12
             :xs    12
             :style {:backgroundColor (if (changed? :eventAlarm-orgId) "#ffd6d2" "#ffffff") :padding-left "-10px"}
             }
            [(org-selector/get-org-selector !orgId (d-rights/get-rights-orgId-filter d-rights/CLASSIC) {:longRow 1 :border "" :readonly (not @!edit-mode)})]
            ]

           [mui/grid
            {:item true
             :xl   6
             :md   12
             :xs   12
             }]

           [mui/grid
            {:container false :item true
             :xl        3
             :md        5
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :eventAlarm-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:eventAlarm-name @!actual-alarm))
                             :onChange     (fn [e] (change-fn :eventAlarm-name (h/event-value e)))
                             :label        "Alarmierung Name"}]
            ]

           [mui/grid
            {:container false :item true
             :xl        5
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/form-control
             {
              :fullWidth true
              }
             [mui/form-label {:style {:font-size 12}} "Alarmierungs Optionen"]]
            [mui/select
             {:multiple  false
              :fullWidth true
              :disabled     (not @!edit-mode)
              :value     (or (:eventAlarm-channel @!data) (:eventAlarm-channel @!actual-alarm) "")
              :onChange  (fn [e] (change-fn :eventAlarm-channel (h/event-value e)))
              }
             [mui/menu-item {:value "email"} [mui/list-item-text "Nur Email"]]
             [mui/menu-item {:value "push"} [mui/list-item-text "Nur Push"]]
             [mui/menu-item {:value "sms"} [mui/list-item-text "Nur SMS"]]
             [mui/menu-item {:value "pushOrSms"} [mui/list-item-text "Push/SMS"]]
             [mui/menu-item {:value "pushAndEmail"} [mui/list-item-text "Push und Email"]]
             [mui/menu-item {:value "pushOrSmsAndEmail"} [mui/list-item-text "Push/SMS und Email"]]
             ]]

           [mui/grid
            {:item true
             :xl   12
             :md   12
             :xs   12
             }]

           [mui/card-actions
            (when (and (not @!edit-mode) (not disabled))
              [mui/button {
                           :variant   "contained"
                           :startIcon (r/as-element [edit])
                           :onClick   #(set-edit-mode-fn true)
                           } "Bearbeiten"])

            (when (and (not @!edit-mode) disabled (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE (:eventAlarm-orgId @!actual-alarm)))
              [mui/button {
                           :variant   "outlined"
                           :style     {:color "orange"}
                           :startIcon (r/as-element [edit])
                           :onClick   #(set-edit-mode-fn true)
                           } "Bearbeiten (superuser)"])

            (when (and @!edit-mode)
              [mui/button {
                           :variant   "contained"
                           :startIcon (r/as-element [keyboard-arrow-left])
                           :onClick   #(set-edit-mode-fn false)
                           } "Abbrechen"])

            (when (and @!edit-mode)
              [mui/button {
                           :variant   "contained"
                           :color     "primary"
                           :startIcon (r/as-element [save])
                           :disabled  (or (not has-changes?))
                           :onClick   (fn []
                                        (d-eventAlarm/>alarm-save (:eventAlarm-uuid @!actual-alarm)
                                                                  (merge @!data
                                                                         [:eventAlarm-orgId (if (and @!orgId (not= "" @!orgId)) @!orgId (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC)))])
                                                                  (fn [data]
                                                                    (reset! !actual-alarm data))))
                           } "Speichern"])

            ]]
          ]]

        ))))



(defn get-it [!actual-alarm !event-detail-loaded? disabled]
  (let []
    [mui/card-content {:style {:textAlign "left"}}

     [(get-base !actual-alarm !event-detail-loaded? disabled)]
     [:br]
     [(event-selector/get-it !actual-alarm !event-detail-loaded? disabled)]
     [:br]
     (when (some #{(:eventAlarm-channel @!actual-alarm)} ["sms" "pushOrSms" "pushOrSmsAndEmail"])
       [:div [(alarm-message/get-alarmMessage-sms !actual-alarm !event-detail-loaded? disabled)]
        [:br]])
     (when (some #{(:eventAlarm-channel @!actual-alarm)} ["push" "pushOrSms"  "pushAndEmail" "pushOrEmail" "pushOrSmsAndEmail"])
       [:div [(alarm-message/get-alarmMessage-push !actual-alarm !event-detail-loaded? disabled)]
        [:br]])
     (when (some #{(:eventAlarm-channel @!actual-alarm)} ["email" "pushOrEmail" "pushAndEmail" "pushOrSmsAndEmail"])
       [:div [(alarm-message/get-alarmMessage-email !actual-alarm !event-detail-loaded? disabled)]])]
    ))





